import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import DlGroup from "./../models/DlGroup";
import { unitScanIndSet } from "../actions";
import { dlUnitScanCountGet } from "../selectors";
import "./App.css";
import "../index.scss";
import "./Sidemenu.scss";
import DlUnit from "../models/DlUnit";

let ScanMenu = null;

const mapStateToProps = state => ({
    dlUnit: state.dlUnit.dlUnit,
    scanInd: state.dlUnit.scanInd,
    scanCount: dlUnitScanCountGet(state)
});

const mapDispatchToProps = dispatch => ({
    unitScanIndSet: payload => dispatch(unitScanIndSet(payload))  
});
  
ScanMenu = ({ scanInd, unitScanIndSet, scanCount, dlUnit }) => {
    const [itemTitle, itemTitleSet] = useState('');
    useEffect(
        function() {
            let item = new DlUnit();
            item.obSet(dlUnit);
            const title = item.unitTitleGet();
            itemTitleSet(title);
        },
        [dlUnit]
    );
    
    const maxNumNav = 30;
    let indFirst = scanInd - parseInt(maxNumNav / 2);
    let numNav = [];
    if (indFirst < 0) {
        indFirst = 0;        
    }
    let indLast = indFirst + maxNumNav - 1;
    if (indLast >= scanCount) {
        indLast = scanCount - 1;        
    }
    for (let i = indFirst; i <= indLast; i++) {
        let classLi = 'num-nav';
        if (i == scanInd) {
            classLi += ' num-nav-act';            
        }
        numNav.push((<span key={ i } className={ classLi } onClick={ () => unitScanIndSet(i) }>{ i + 1 }</span>));       
    }

    let comp = null;
    if (scanCount > 0) {
        comp = (
            <React.Fragment>
                <div className="points-p">
                <img src="/images/tackice.jpg" alt="citajte o" />
                </div>
                <div style={{ marginTop: '0.5em', color: 'black', lineHeight: '1.2em' }}>
                    { itemTitle }
                </div>
                
                <div className="scan-li-nav" style={{ marginTop: '0.5em' }}>
                    <span onClick={ () => unitScanIndSet(0) }>&lt;&lt;</span>
                    <span onClick={ () => unitScanIndSet(scanInd - 1) }>&lt;</span>
                    <span onClick={ () => unitScanIndSet(scanInd + 1) }>&gt;</span>
                    <span onClick={ () => unitScanIndSet(scanCount - 1) }>&gt;&gt;</span>
                </div>
                <div className="scan-li-nav">
                    <span style={{ marginLeft: '0%', marginTop: '0.5em' }}>{scanInd + 1}</span>
                    <span style={{ marginLeft: '1%' }}>/</span>
                    <span style={{ marginLeft: '1%' }}>{scanCount}</span>                
                </div>
                <div style={{ width: '100%', marginTop: '0.5em' }}>
                </div>
                <div className="num-nav-p" style={{ width: '100%', marginTop: '0.5em' }}>
                    { numNav }
                </div>
            </React.Fragment>
        );            
    }
  
    return comp;
};

export default connect(mapStateToProps, mapDispatchToProps)(ScanMenu);
